import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { MemoryRouter, Route } from 'react-router-dom';
import App from './sso/components/app';
import 'tachyons';

ReactDOM.createRoot(document.getElementById('root')).render(
  <MemoryRouter>
    <Route component={App} />
  </MemoryRouter>,
);
